import { render, staticRenderFns } from "./ActividadesLista.vue?vue&type=template&id=4009b9aa&scoped=true"
import script from "./ActividadesLista.vue?vue&type=script&lang=js"
export * from "./ActividadesLista.vue?vue&type=script&lang=js"
import style0 from "./ActividadesLista.vue?vue&type=style&index=0&id=4009b9aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4009b9aa",
  null
  
)

export default component.exports